import { STATUS_INIT } from 'constants/statuses.constants';

export const getInitialState = () => ({
  users: [],
  status: STATUS_INIT,
  error: null,
});
